<template>
	<div :id="id"></div>
</template>




<script>


import chartsInit from "@/utils/chartsInit"

//主题
import  'echarts/theme/macarons.js'
//import  'echarts/theme/vintage.js'

let echarts = require('echarts/lib/echarts')

// 引入组件
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')



export default {
	props: ["id","data","type","title","unit","tip","toolbox","x","x2","y","y2","max","min","label",
	"valuefield","namefield","radius","legend","center","subtext","rotate"],
	data() {
		return {
			
		};
	},
	methods: {
        drawChart() {
			let myChart = echarts.init(document.getElementById(this.id),'macarons');  
			          
			var params = {data:this.data,type:this.type,title:this.title,unit:this.unit,tip:this.tip,
			toolbox:this.toolbox,max:this.max,min:this.min,x:this.x,x2:this.x2,y:this.y,y2:this.y2,
			label:this.label,namefield:this.namefield,valuefield:this.valuefield,radius:this.radius,
			legend:this.legend,center:this.center,subtext:this.subtext,rotate:this.rotate};
			//console.log(params);
			if(params.type.indexOf("bar") >= 0 || params.type.indexOf("line") >= 0)
			{
				if(params.type.indexOf("multiple") > 0)
				{
					params.type = params.type.replace("|multiple","");
					myChart.setOption(chartsInit.multipleBarlineOps(params));
				}
				else{				
					myChart.setOption(chartsInit.singleBarlineOps(params));
				}
			}
			if(params.type.indexOf("pie") >= 0 || params.type.indexOf("circle") >= 0)
			{
				myChart.setOption(chartsInit.pieOps(params));
			}
        }
    },
    mounted() {
		if(!util.isEmpty(this.data) && this.data.length > 0){
        	this.drawChart();
		}
	},
	watch: {
		'data': function (val) {
			this.data = val;
        	this.drawChart();
		}
	},
};
</script>



